import React from 'react';

export const InitialDataContext = React.createContext({});

export function InitialDataProvider({ data = {}, children }) {
  return (
    <InitialDataContext.Provider value={data}>
      {children}
    </InitialDataContext.Provider>
  );
}

export function useInitialData(key) {
  const ctx = React.useContext(InitialDataContext);
  return ctx ? ctx[key] : undefined;
}

export default InitialDataProvider;
